import React from "react";
import translate from "../../common/functions/translate";
import Div from "../../common/components/div";
import H1 from "../../common/components/h1";

export const CreateAccountMaintenance = () => {
    return (
        <Div isContainer paddingy={1} paddingyMD={2}>
            <Div className="ds-u-justify-content--center ds-u-display--flex ds-u-padding--1 ds-u-margin-top--7">
                <Div className="ds-u-justify-content-center">
                    <Div isRow className="ds-u-justify-content--center ds-u-margin-bottom--2">
                        <H1>
                            {translate("system_maintenance")}
                        </H1>
                    </Div>
                    <Div isRow className="ds-u-justify-content--center ds-u-margin-bottom--1">
                        <p className="ds-u-margin--0">
                            {translate("create_account_unavailable")}
                        </p>
                    </Div>
                    <Div isRow className="ds-u-display--flex ds-u-justify-content--center">
                        <p className="ds-u-margin--0">
                            {translate('visit')} {' '} <a href={translate("medicare_url")}>Medicare.gov</a> {' '} {translate('for_the_latest')}
                        </p>
                    </Div>
                </Div>
            </Div>
        </Div>
    )
}
